import { normalizeRegimen, REGIMEN_ORDER } from '../../helpers/regimen';

const sortByRegimenOrder = filters =>
  [...filters].sort((a, b) => {
    const indexA = REGIMEN_ORDER.indexOf(a.type);
    const indexB = REGIMEN_ORDER.indexOf(b.type);

    if (indexA === -1 && indexB === -1) {
      return 0;
    }
    if (indexA === -1) {
      return 1;
    }
    if (indexB === -1) {
      return -1;
    }

    return indexA - indexB;
  });

export const buildRegimenList = hotelSearchResults => {
  const filters = [];

  hotelSearchResults.forEach(hotel => {
    hotel.rates.forEach(rate => {
      const rawDescription = rate.board?.description;
      const description = rawDescription?.split('(')?.[0]?.trim();

      if (!description) {
        return;
      }

      const { label, isCustom } = normalizeRegimen(description);

      const exists = filters.some(f => f.type === label);
      if (!exists) {
        filters.push({ type: label, state: true, isCustom });
      }
    });
  });

  return sortByRegimenOrder(filters);
};

const getRegimenLabel = rate => {
  const description = rate.board?.description?.split('(')?.[0]?.trim();
  return description ? normalizeRegimen(description).label : null;
};

export const calculatePriceRange = (
  hotels,
  totalNights,
  regimen = 'allOptions'
) => {
  let min = Infinity;
  let max = -Infinity;

  for (const hotel of hotels) {
    for (const rate of hotel.rates ?? []) {
      if (regimen !== 'allOptions' && getRegimenLabel(rate) !== regimen) {
        continue;
      }

      const room = rate?.rooms?.[0];
      const availability = room?.availability;
      const totalPrice = rate?.price?.details_USD?.total;

      if (!room || availability === 'ORQ' || !totalPrice) {
        continue;
      }

      const price = Math.ceil(totalPrice / totalNights);

      if (price < min) {
        min = price;
      }
      if (price > max) {
        max = price;
      }
    }
  }

  return [Number.isFinite(min) ? min : 0, Number.isFinite(max) ? max : 0];
};
